import { squareConfig } from "./squarePOS"

const oauthConfigs = {
    square: squareConfig,
};

export default oauthConfigs;